import { Injectable } from '@angular/core';
import { RouterParamsService } from '../../shared/services/router-params.service';
import { Allergy } from '../models/previous-allergies';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { EntityManagementService } from '../entity-management/services/base/entity-management.service';

@Injectable({
  providedIn: 'root',
})
export class AllergiesEntityService extends BaseEntityService<Allergy> {

  constructor(
    httpClient: HttpClient,
    routerParamsService: RouterParamsService,
  ) {
    super(
      httpClient,
      environment.apiUrl, { singular: 'allergy', plural: 'allergies', url: 'allergies' },
      routerParamsService
    );
    this.nameId = 'allergyId';
  }
}
